/**
 * Manage global libraries like jQuery or THREE from the webpack.mix.js file
 */

// Import custom modules
import App from './modules/app.js';

new App();
